import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  AuthConfig,
  JwksValidationHandler,
  OAuthModule,
  ValidationHandler,
  OAuthModuleConfig
} from 'angular-oauth2-oidc';

import { AppSettings } from './entities/AppSettings';



import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { enableProdMode } from '@angular/core';

enableProdMode();


//PrimeNG


//import { authConfigFactory } from './shared/components/auth/auth-config-factory';
import { AppSettingsService } from './services/app-settings/app-settings.service';
import { HomeComponent } from './modules/app/pages/home/home.component';
import { BASE_URL } from './modules/shared/components/app.tokens';
import { SharedModule } from './modules/shared/shared.module';
import { MfSidebarComponent } from './modules/shared/components/mf-sidebar/mf-sidebar.component';
//import { ParticlesModule } from 'angular-particle';
import { GridModule } from '@progress/kendo-angular-grid';
import { ScrollViewModule } from '@progress/kendo-angular-scrollview';
import { DialogsModule } from '@progress/kendo-angular-dialog';


import { ToastrModule } from 'ngx-toastr';
import { TreeViewModule } from '@progress/kendo-angular-treeview';
import { TreeListModule } from '@progress/kendo-angular-treelist';
import { ChartsModule } from '@progress/kendo-angular-charts';
import 'hammerjs';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';




@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    MfSidebarComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    AppRoutingModule,
    HttpClientModule, 
    SharedModule.forRoot(),
    // ParticlesModule,
    ToastrModule.forRoot(), // ToastrModule added
    TreeViewModule,
    //OAuthModule.forRoot()
    OAuthModule.forRoot({
      resourceServer: {
        allowedUrls: ['https://localhost:44351', 'http://sad-api.mattafix.net/', 'https://sad-api.mattafix.net/', 'https://test-sad-api.mattafix.net/', 'https://dev-sad-api.mattafix.net/', 'https://api.southey.co.za/', 'https://test-api.southey.co.za/'],
      sendAccessToken: true
      }
    }),

    GridModule,

    ScrollViewModule,

    DialogsModule,

    TreeListModule,

    ChartsModule,
      ServiceWorkerModule.register('ngsw-worker.js', {
        enabled: environment.production,
        // Register the ServiceWorker as soon as the application is stable
        // or after 30 seconds (whichever comes first).
        registrationStrategy: 'registerWhenStable:30000'
      })
  ],
  providers: [
    {
      provide: BASE_URL, useValue: 'https://localhost:44351'
    },
    { provide: MAT_DIALOG_DATA, useValue: {} },
    { provide: MatDialogRef, useValue: {} }
  ],
  exports: [TreeViewModule],
  bootstrap: [AppComponent]
})
export class AppModule { }
